import { render, staticRenderFns } from "./PresupuestoSinSDI.vue?vue&type=template&id=49c663e8&scoped=true"
import script from "./PresupuestoSinSDI.vue?vue&type=script&lang=js"
export * from "./PresupuestoSinSDI.vue?vue&type=script&lang=js"
import style0 from "./PresupuestoSinSDI.vue?vue&type=style&index=0&id=49c663e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c663e8",
  null
  
)

export default component.exports